
export default {
  name: 'VsGridCol',
  props: {
    span: {
      type: [String, Number, Object],
      default: null
    },
    start: {
      type: [String, Number, Object],
      default: null
    },
    end: {
      type: [String, Number, Object],
      default: null
    },
    order: {
      type: [String, Number, Object],
      default: null
    },
    tag: {
      type: String,
      default: 'div'
    }
  },
  vessel: {
    default: {
      $attrs: 'all',
      $span: 'gridColumnSpan',
      $start: 'gridColumnStart',
      $end: 'gridColumnEnd',
      $order: 'gridColumnOrder'
    }
  }
}
